import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { FlexWrapperProps, LabelWrapperProps } from './types'

export const LabelWrapper = styled('label')<LabelWrapperProps>`
  ${props =>
    props.gridArea &&
    css`
      grid-area: ${props.gridArea};
    `}
`

export const RequiredMark = styled('span')`
  color: ${props => props.theme.colors.main.error};
  margin-left: 2px;
`

export const FlexWrapper = styled(Flex).attrs({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
})<FlexWrapperProps>`
  min-height: ${props => props.flexWrapperMinHeight || '28px'};

  p {
    margin-top: ${props => props.fontMarginTop || '4px'};
  }

  ${props => props.fontMarginTop && css `
    p {
      margin-bottom: ${props.fontMarginBottom};
    }
  `}

  ${props => props.flexWrapperCentered && css `
    align-items: center;
    min-height: 36px;

    p {
      margin-top: 0;
    }
  `}
`

export const FixedWidthContainer = styled('div')<{width: string}>`
    width: ${props => props.width}
`
